import { render, staticRenderFns } from "./slaDetails.vue?vue&type=template&id=2b104cd2&scoped=true&"
import script from "./slaDetails.vue?vue&type=script&lang=js&"
export * from "./slaDetails.vue?vue&type=script&lang=js&"
import style0 from "./slaDetails.vue?vue&type=style&index=0&id=2b104cd2&scoped=true&lang=css&"
import style1 from "./slaDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b104cd2",
  null
  
)

export default component.exports